// extracted by mini-css-extract-plugin
export var anim = "bannerD-module--anim--s0A-E";
export var banner = "bannerD-module--banner--1oSrz";
export var icon = "bannerD-module--icon--2KM4Q";
export var mouve = "bannerD-module--mouve--VnLXY";
export var warning = "bannerD-module--warning--YNnLn";